@if (orderReturnData$ | async; as order) {
  @if (order.returnEntries) {
    <div class="customersearch-list-table border-bottom mt-3 float-left col-lg-12 p-0">
      <div
        class="customersearch-list-titles border-top float-left w-100 pl-2 pr-2 pt-3 pb-3 d-none d-sm-none d-lg-block"
        >
        <div class="col-md-2 float-left font-text-400 font-md-size text-muted">
          {{ 'knbrReturnOrderDetails.label.product' | cxTranslate }}
        </div>
        <div class="col-md-2 float-left font-text-400 font-md-size text-muted">
          {{ 'knbrReturnOrderDetails.label.skuNumber' | cxTranslate }}
        </div>
        <div class="col-md-3 float-left font-text-400 font-md-size text-muted pl-1">
          {{ 'knbrReturnOrderDetails.label.description' | cxTranslate }}
        </div>
        <div class="col-md-2 float-left font-text-400 font-md-size text-muted">
          {{ 'knbrReturnOrderDetails.label.returnQty' | cxTranslate }}
        </div>
        <!-- <div class="col-md-3 float-left font-text-400 font-md-size text-muted">
        {{ 'knbrReturnOrderDetails.label.itemNetPrice' | cxTranslate }}
      </div> -->
    </div>
  </div>
  @if (order.returnEntries) {
    @for (item of order.returnEntries; track item) {
      <div
        class="bg-white customersearch-list-titles table-content border-top float-left w-100 py-2 pr-3 font-weight-normal d-flex align-items-center"
        >
        <div class="col-md-2 text-center title-wrap padding-res-0 float-left">
          <cx-media [container]="item.orderEntry?.product?.images?.PRIMARY" format="product"></cx-media>
        </div>
        <div class="col-md-2 text-align-right title-wrap font-md-size color-font font-text-600">
          <span class="res-titles"> {{ 'knbrReturnOrderDetails.label.skuNumber' | cxTranslate }}</span>
          <a  class="cx-link">{{ item.orderEntry?.product?.code }}</a>
        </div>
        <div class="col-md-3 float-left title-wrap font-md-size color-font">
          <span class="res-titles"> {{ 'knbrReturnOrderDetails.label.description' | cxTranslate }}</span>
          {{ item.orderEntry?.product?.name }}
        </div>
        <div class="col-md-2 text-align-right title-wrap font-md-size color-font">
          <span class="res-titles"> {{ 'knbrReturnOrderDetails.label.returnQty' | cxTranslate }} </span>
          {{ item?.expectedQuantity?.toLocaleString() }} {{ item?.uom}}
        </div>
        <!-- <div class="col-md-3 float-left title-wrap font-md-size color-font">
        <span class="res-titles">{{ 'knbrReturnOrderDetails.label.itemNetPrice' | cxTranslate }} </span>
        {{ item.orderEntry?.basePrice?.formattedValue }}
      </div> -->
    </div>
  }
}
}
<div class="col-md-12 float-right d-flex justify-content-center mt-4">
  <button type="button" class="btn btn-action col-md-3" (click)="goBack()">
    {{ 'knbrReturnOrderDetails.actions.backOrderReturns' | cxTranslate }}
  </button>
</div>
}
